/**
 * Resolve a `?tab=<key>` deep link (used by email buttons) to a dashboard tab index.
 * @param {string} search - location.search, e.g. "?tab=scheduled-maintenance"
 * @param {Record<string, number>} tabByKey
 * @returns {number|null} the tab index, or null when absent or unknown
 */
export function tabFromSearch(search, tabByKey) {
  const key = new URLSearchParams(search || '').get('tab');
  if (!key || !Object.prototype.hasOwnProperty.call(tabByKey, key)) return null;
  return tabByKey[key];
}

const QUICKBOOKS_PATHS = { '/quickbooks': null, '/quickbooks/connect': 'connect', '/quickbooks/disconnected': 'disconnected' };
const QUICKBOOKS_RESULTS = ['connected', 'cancelled', 'expired', 'error'];

/**
 * QuickBooks links registered with Intuit (launch, connect, disconnect) and the `?qb=` result
 * the API callback sends back.
 * @returns {{ action: 'connect'|'disconnected'|null, result: string|null } | null}
 */
export function quickbooksLinkFrom(pathname, search) {
  const path = String(pathname || '').replace(/\/+$/, '');
  if (!Object.prototype.hasOwnProperty.call(QUICKBOOKS_PATHS, path)) return null;
  const qb = new URLSearchParams(search || '').get('qb');
  return { action: QUICKBOOKS_PATHS[path], result: QUICKBOOKS_RESULTS.includes(qb) ? qb : null };
}

/** Login redirect target that keeps the query string (so deep links survive sign-in). */
export function destinationFrom(from) {
  if (!from?.pathname) return '/';
  return `${from.pathname}${from.search || ''}`;
}
